import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as Api from 'api';
import * as Permissions from 'permissions';
import * as Actions from 'actions';
import { connect } from 'react-redux';
import { Modal, Button } from 'react-bootstrap';

class __ListDownloadButton extends Component {
  constructor(props) {
    super(props);
    this.triggerDownload = this.triggerDownload.bind(this);
    this.handleDownload = this.handleDownload.bind(this);
    this.close = this.close.bind(this);

  }
  state = {
    file: undefined,
    showConfirmation: false,
  }
  static propTypes = {
    mapID: PropTypes.string,
    featureID: PropTypes.string,
  }
  handleDownload() {
    this.setState({ loading: true, showConfirmation: false });
    Api.listDataXLS(this.props.mapID, this.props.featureID)
      .then(response => this.setState({message: response.message, file: response.file, loading: false}))
      .catch(ex => this.setState({error: ex.message || 'An error occurred.', loading:false}))
  }
  componentDidUpdate(prevProps) {
    if(prevProps.mapID != this.props.mapID || prevProps.featureID != this.props.featureID) {
      this.setState({file: undefined, error: undefined, message: undefined});
    }
  }
  triggerDownload() {
    this.setState({ showConfirmation: true });
  }
  close() {
    this.setState({ showConfirmation: false });
  }
  render() {
    const { user, mapID, featureID } = this.props;

    if(!mapID || !featureID || !this.props.hasPermission(Permissions.DOWNLOAD_DATA_LIST)) {
      return null;
    }
    if(this.state.error) {
      return (
        <div className="animated fadeInUp alert alert-danger clearfix">
          <span onClick={e => this.setState({error: undefined})} className="btn btn-default pull-right">Clear</span>
          <p>{this.state.error}</p>
        </div>
      )
    }
    return (
      <div>
        {this.state.message && !this.state.file ? <div className="alert alert-success">
          <p>{this.state.message}</p>
        </div>: null}
        <div className="animated fadeInDown btn-group">
          {this.state.loading ?
            <div className="btn btn-default"><i className="fa fa-spin fa-spinner"></i> Loading</div>
            :<div onClick={this.triggerDownload} className="btn btn-info"><i className="fa fa-cloud-download"></i> Impacted Contacts</div>}
          {this.state.file ?
            <a href={this.state.file.url} target="_blank" className="btn btn-success"><i className="fa fa-download"></i></a>
          : null}
        </div>
        <Modal bsStyle={'danger'} show={this.state.showConfirmation} onHide={this.close}>
          <Modal.Header closeButton>
            <Modal.Title>Confirm Download</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            By downloading this list, you are agreeing <a href='https://www.coleinformation.com/legal/terms-and-conditions.aspx/' target='_blank'><i className='fa fa-external-link-square'></i> to our data partner's TOS</a>.
            Specifically, you are agreeing to the following: <br /><br />
            <blockquote>
              <span className="text-primary">11.8 Do Not Call ("DNC").</span> Client acknowledges that certain laws, rules and regulations restrict telemarketing activities, including those that permit consumers to give notice that they do not wish to receive telephone solicitation calls. Due to the varying and changing nature of such laws, rules and regulations and the nature of Client’s intended use of (COLE Data within fixed media), COLE makes no warranty that the names or telephone numbers of such individuals have been identified on or deleted from the COLE Data and shall have no liability with respect thereto.
            </blockquote>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.close}>Close</Button>
            <Button bsStyle='primary' onClick={this.handleDownload}><i className='fa fa-square-o'></i> I Agree, Download my List.</Button>
          </Modal.Footer>
        </Modal>
      </div>
    )
  }
}

export default connect(({connection}) => ({user: connection.user}), Actions)(__ListDownloadButton);



// WEBPACK FOOTER //
// ./src/browser/components/data/list-download-button.js